import { useState } from 'react';
import cookie from 'js-cookie';
import './HeaderAlert.css';
import { ReactComponent as CloseCrossWhite } from './close-cross-white.svg';

function headerContent(lang: string): JSX.Element {
  switch (lang) {
    case 'de':
      return <div>92% unserer Gäste würden uns weiterempfehlen</div>;
    case 'fr':
      return <div>92% de nos clients nous recommanderaient</div>;
    case 'nl':
      return <div>92% van onze gasten zou ons aanbevelen</div>;
    case 'es':
      return <div>El 92% de nuestros huéspedes nos recomendaría</div>;
    default:
      return <div>92% of our guests would recommend us</div>;
  }
}

interface HeaderAlertProps {
  lang: string;
}

const cookieName = 'cpl-dismiss-header';
const cookieExpirationDays = 7;

export default function HeaderAlert({ lang }: HeaderAlertProps): JSX.Element | null {
  const [hide, setHide] = useState(cookie.get(cookieName) === 'true');

  function handleDismiss(): void {
    cookie.set(cookieName, 'true', { expires: cookieExpirationDays });
    setHide(true);
  }

  if (hide) {
    return null;
  }

  return (
    <div className="headeralert">
      <div className="headeralert__content">{headerContent(lang)}</div>
      <div className="headeralert__close">
        <button type="button" aria-label="Close alert" onClick={handleDismiss}>
          <CloseCrossWhite />
        </button>
      </div>
    </div>
  );
}
